import React from "react";
import type { ICellRendererParams } from "ag-grid-enterprise";
import type { RoomValidationDiffItem } from "@backend/src/shared/schemas/room/roomValidationSchema";
import { CompCodeName } from "./CompCodeName";
import { ValidationDeltaStatusIcon } from "./ValidationDeltaStatusIcon";

type Props = ICellRendererParams<RoomValidationDiffItem> & { occurrenceLayout: boolean; renderComponentAction?: (compCode: string) => React.ReactNode };
export const ValidationComponentCell = ({ data, occurrenceLayout, renderComponentAction }: Props) =>
  occurrenceLayout ? (
    <div className="occurrence-component" title={data?.label ?? undefined}>
      <div className="occurrence-component-code">
        <strong>{data?.compCode || "—"}</strong>
        {data?.compCode && renderComponentAction?.(data.compCode)}
      </div>
      <span>{data?.label}</span>
    </div>
  ) : (
    <CompCodeName compCode={data?.compCode} name={data?.label} tooltipFallback="No type name" />
  );

export const ValidationCountCell = ({ value, data, occurrenceLayout }: Props) =>
  occurrenceLayout ? (
    <span>{value ?? "–"}</span>
  ) : (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 8,
        height: "100%",
      }}
    >
      <ValidationDeltaStatusIcon delta={data?.delta} size={18} />
      <span>{value ?? "–"}</span>
    </div>
  );

export const ValidationDeltaCell = ({
  value,
}: ICellRendererParams<RoomValidationDiffItem, number>) => (
  <span className={value === 0 ? "occurrence-match" : "occurrence-delta"}>
    {value != null && value > 0 ? `+${value}` : value}
  </span>
);
